import { render, staticRenderFns } from "./LinkView.vue?vue&type=template&id=9921d888&scoped=true&"
import script from "./LinkView.vue?vue&type=script&lang=js&"
export * from "./LinkView.vue?vue&type=script&lang=js&"
import style0 from "./LinkView.vue?vue&type=style&index=0&id=9921d888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9921d888",
  null
  
)

export default component.exports